import React from "react";

function PolygonUp() {
  return (
    <svg
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 0L8 4H0L4 0Z" fill="#05CD99" />
    </svg>
  );
}

export default PolygonUp;
